(() => {
'use strict';
const states = new Map();
const motion = matchMedia('(prefers-reduced-motion: reduce)');
const phone = matchMedia('(max-width: 767px)');
const allowed = () => !motion.matches && !navigator.connection?.saveData;
const pause = state => {
 const pending = state.pending;
 state.attempt++; state.pending = false;
 if (pending || !state.video.paused) state.video.pause();
 state.video.classList.remove('is-playing');
};
const playable = state => !state.disposed && state.video.isConnected && allowed() && state.ready && state.visible && !document.hidden;
const sync = state => {
 if (!playable(state)) { pause(state); return; }
 const mode = phone.matches ? 'phone' : 'desktop';
 if (state.mode !== mode) {
  pause(state); state.video.replaceChildren();
  for (const format of ['mp4','webm']) {
   const source = document.createElement('source');
   source.src = state.video.dataset[mode + (format === 'webm' ? 'Webm' : 'Mp4')];
   source.type = format === 'webm' ? 'video/webm' : 'video/mp4';
   state.video.append(source);
  }
  state.mode = mode; state.video.load();
 }
 state.video.muted = true;
 if (state.pending || !state.video.paused) return;
 const attempt = ++state.attempt;
 state.pending = true;
 try {
  Promise.resolve(state.video.play()).then(() => {
   if (attempt !== state.attempt) return;
   state.pending = false;
   if (!playable(state)) pause(state);
  }, () => {
   if (attempt === state.attempt) pause(state);
  });
 } catch { if (attempt === state.attempt) pause(state); }
};
const observer = new IntersectionObserver(entries => entries.forEach(entry => {
 const state = states.get(entry.target);
 if (state) { state.visible = entry.isIntersecting; sync(state); }
}), { rootMargin: '80px' });
const dispose = state => {
 state.disposed = true;
 clearTimeout(state.timer);
 state.cleanupReady(); state.events.abort();
 observer.unobserve(state.video); pause(state); states.delete(state.video);
};
const init = () => document.querySelectorAll('[data-damascus-video]').forEach(video => {
 if (states.has(video)) return;
 const state = { video, visible: false, mode: '', ready: false, disposed: false, pending: false, attempt: 0, timer: 0, events: new AbortController() }; states.set(video,state);
 const primary = document.querySelector('[data-hero-item].is-active img, .main-image .media-panel:not([hidden]) img');
 const ready = () => {
  state.cleanupReady();
  if (state.disposed || !video.isConnected) { if (!state.disposed) dispose(state); return; }
  state.ready = true; sync(state);
 };
 state.cleanupReady = () => {
  clearTimeout(state.timer); state.timer = 0;
  primary?.removeEventListener('load',ready); primary?.removeEventListener('error',ready);
 };
 if (primary && !primary.complete) {
  primary.addEventListener('load',ready,{once:true,signal:state.events.signal}); primary.addEventListener('error',ready,{once:true,signal:state.events.signal});
  state.timer = setTimeout(ready,2000);
 } else state.timer = setTimeout(ready,300);
 video.addEventListener('playing', () => {
  if (playable(state)) video.classList.add('is-playing'); else pause(state);
 }, {signal:state.events.signal});
 video.addEventListener('error', () => pause(state), {signal:state.events.signal});
 observer.observe(video);
});
const refresh = () => states.forEach(state => {
 if (!state.video.isConnected) dispose(state);
 else sync(state);
});
motion.addEventListener('change',refresh); phone.addEventListener('change',refresh);
document.addEventListener('visibilitychange',refresh);
document.addEventListener('shopify:section:load',init);
document.addEventListener('shopify:section:unload',event => states.forEach(state => {
 if (event.target.contains(state.video) || !state.video.isConnected) dispose(state);
}));
window.addEventListener('pageshow',refresh);
window.addEventListener('pagehide',() => states.forEach(pause));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
